export default __webpack_public_path__ + "static/media/Kingsmight Ale.285ff7d5.jpg";